export type EventMap = Record<string, unknown>;

type Handler<T> = (payload: T) => void;

type Handlers<T extends EventMap> = {
  [K in keyof T]?: Set<Handler<T[K]>>;
};

export class EventBus<T extends EventMap> {
  private handlers: Handlers<T> = {};

  on<K extends keyof T>(event: K, handler: Handler<T[K]>) {
    if (!this.handlers[event]) {
      this.handlers[event] = new Set();
    }
    this.handlers[event]!.add(handler);
    return () => this.off(event, handler);
  }

  off<K extends keyof T>(event: K, handler: Handler<T[K]>) {
    this.handlers[event]?.delete(handler);
  }

  emit<K extends keyof T>(event: K, payload: T[K]) {
    this.handlers[event]?.forEach((handler) => handler(payload));
  }
}
